import React from 'react';
import { PhoneIcon, MailIcon, UserIcon, ClockIcon } from 'lucide-react';
export const PreviousManagement = () => {
  return <div className="space-y-8" data-id="element-1049">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1050">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1051">
          Historial de Gestiones
        </h2>
        <div className="space-y-6" data-id="element-1052">
          <div className="relative" data-id="element-1053">
            <div className="flex items-start" data-id="element-1054">
              <div className="flex items-center justify-center h-10 w-10 rounded-full bg-blue-100 text-blue-600 mr-4" data-id="element-1055">
                <PhoneIcon className="h-5 w-5" data-id="element-1056" />
              </div>
              <div className="flex-1 min-w-0 bg-gray-50 rounded-lg p-4" data-id="element-1057">
                <div className="flex justify-between" data-id="element-1058">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-1059">
                    Llamada Telefónica
                  </h3>
                  <span className="text-xs text-gray-500" data-id="element-1060">15/03/2024</span>
                </div>
                <p className="mt-1 text-sm text-gray-600" data-id="element-1061">
                  Cliente interesado en negociar su deuda. Solicitó información
                  sobre posibles descuentos.
                </p>
                <div className="mt-2 flex items-center" data-id="element-1062">
                  <UserIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-1063" />
                  <span className="text-xs text-gray-500" data-id="element-1064">
                    Gestor: María López
                  </span>
                  <ClockIcon className="h-4 w-4 text-gray-400 ml-3 mr-1" data-id="element-1065" />
                  <span className="text-xs text-gray-500" data-id="element-1066">
                    Duración: 8:35 min
                  </span>
                </div>
              </div>
            </div>
            <div className="absolute top-0 left-5 h-full w-0.5 bg-gray-200 -z-10" data-id="element-1067"></div>
          </div>
          <div className="relative" data-id="element-1068">
            <div className="flex items-start" data-id="element-1069">
              <div className="flex items-center justify-center h-10 w-10 rounded-full bg-green-100 text-green-600 mr-4" data-id="element-1070">
                <MailIcon className="h-5 w-5" data-id="element-1071" />
              </div>
              <div className="flex-1 min-w-0 bg-gray-50 rounded-lg p-4" data-id="element-1072">
                <div className="flex justify-between" data-id="element-1073">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-1074">
                    Correo Electrónico
                  </h3>
                  <span className="text-xs text-gray-500" data-id="element-1075">01/03/2024</span>
                </div>
                <p className="mt-1 text-sm text-gray-600" data-id="element-1076">
                  Se envió recordatorio de pago con opciones de
                  refinanciamiento.
                </p>
                <div className="mt-2 flex items-center" data-id="element-1077">
                  <UserIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-1078" />
                  <span className="text-xs text-gray-500" data-id="element-1079">
                    Gestor: Carlos Mendoza
                  </span>
                </div>
              </div>
            </div>
            <div className="absolute top-0 left-5 h-full w-0.5 bg-gray-200 -z-10" data-id="element-1080"></div>
          </div>
          <div data-id="element-1081">
            <div className="flex items-start" data-id="element-1082">
              <div className="flex items-center justify-center h-10 w-10 rounded-full bg-blue-100 text-blue-600 mr-4" data-id="element-1083">
                <PhoneIcon className="h-5 w-5" data-id="element-1084" />
              </div>
              <div className="flex-1 min-w-0 bg-gray-50 rounded-lg p-4" data-id="element-1085">
                <div className="flex justify-between" data-id="element-1086">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-1087">
                    Llamada Telefónica
                  </h3>
                  <span className="text-xs text-gray-500" data-id="element-1088">15/02/2024</span>
                </div>
                <p className="mt-1 text-sm text-gray-600" data-id="element-1089">
                  Cliente no contestó. Se dejó mensaje de voz solicitando
                  contacto.
                </p>
                <div className="mt-2 flex items-center" data-id="element-1090">
                  <UserIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-1091" />
                  <span className="text-xs text-gray-500" data-id="element-1092">
                    Gestor: Ana Rodríguez
                  </span>
                  <ClockIcon className="h-4 w-4 text-gray-400 ml-3 mr-1" data-id="element-1093" />
                  <span className="text-xs text-gray-500" data-id="element-1094">
                    Duración: 1:20 min
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1095">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1096">
          Propuestas Anteriores
        </h2>
        <div className="overflow-x-auto" data-id="element-1097">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1098">
            <thead className="bg-gray-50" data-id="element-1099">
              <tr data-id="element-1100">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1101">
                  Fecha
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1102">
                  Monto Original
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1103">
                  Descuento
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1104">
                  Monto Propuesto
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1105">
                  Cuotas
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1106">
                  Estado
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1107">
              <tr data-id="element-1108">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1109">
                  15/02/2024
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1110">
                  S/ 12,450.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1111">
                  20%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1112">
                  S/ 9,960.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1113">
                  6
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1114">
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-1115">
                    Rechazada
                  </span>
                </td>
              </tr>
              <tr data-id="element-1116">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1117">
                  01/01/2024
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1118">
                  S/ 12,450.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1119">
                  15%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1120">
                  S/ 10,582.50
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1121">
                  12
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1122">
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-1123">
                    Expirada
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};